import Model from "./base/model";

class SimulationIntegraOrders extends Model {
  resourceName() {
    return "simulation_integra_orders";
  }

  fields() {
    return {
      order_id: "",
      simulation: "",
      return_simulation: "",
      rates: "",
      config_rates: "",
      lead_time: "",
      total_value: "",
      rates_value: "",
      weight_shipping_value: "",
      alter_rates: "",
      ciltronic: "",
      conference: "",
      order: { jsonApi: "hasOne", type: "orders"},
      simulation_integra_orders_addresses: { jsonApi: "hasMany", type: "simulation_integra_orders_addresses"},
      additional_deliveries: ""
    };
  }

  async updateRates(id, data) {
    return this.request(
      this.resourceName() + `/rates/${id}`,
      "PATCH",
      {},
      data
    );
  }

}

export default new SimulationIntegraOrders();
